// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,BarChart, Bar,PieChart, Pie, Cell } from 'recharts';


import styles from './styles.module.css';
import ChargerMetric from './ChargerMetric';

const LocationMetric = ({ location, fromDate, toDate }) => {

    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isLocationLoading, setIsLocationLoading] = useState(false);
    const [chargersData, setChargersData] = useState([]);

    const [locationMetricData, setLocationMetricData] = useState([]);
    const [locationFinancialData, setLocationFinancialData] = useState([]);
    const [locationUtilizationData, setLocationUtilizationData] = useState([]);
    const [location24hrSessionData, setlocation24hrSessionData ] = useState([])


    const [selectedCharger, setSelectedCharger] = useState(null);

    const [selectedTopTab, setSelectedTopTab] = useState(0);

    const COLORS = ['#40546e', '#00C49F', '#FFBB28', '#FF8042'];

    const formatDuration = (seconds) => {
        if (seconds === 0 || seconds === null) return "0m";
        
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
    
        const hoursStr = hours > 0 ? `${hours}h ` : '';
        const minutesStr = minutes > 0 ? `${minutes}m` : '';
    
        return `${hoursStr}${minutesStr}`.trim();
    };

    const formatDate = (dateString) => {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const dateToConvert = new Date(dateString || Date.now());
        const month = months[dateToConvert.getUTCMonth()];
        const day = dateToConvert.getUTCDate();       
        const year = dateToConvert.getUTCFullYear();
        return `${month} ${day} ${year}`;
    }
    const CustomTooltip2 = ({ payload, label, active }) => {
        if (active && payload && payload.length) {
          
          const [hour, minute] = label.split(':');
          const endTime = `${(parseInt(hour) + 1).toString().padStart(2, '0')}:${minute}`;
          return (
            <div className={styles.customTooltip}>
              <p >{`${label} - ${endTime}`}</p>
              <p >{`Time Utilisation: ${payload[0].value}%`}</p>
            </div>
          );
        }
      
        return null;
      };



    const fetchLocationData = async () => {
        try {
            setIsLoading(true);
            setLocationMetricData([]);
            const data = await BreathAPIs.getLocationMetric(location?._id, fromDate, toDate, true);
            setLocationMetricData(data.data.energyDetails);
            setChargersData(data.data.energyDetails.chargerDetails);
            
        } catch (error) {
            console.error('Error fetching location data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchLocation24hrSessionUtilisationData = async () => {
        try {
            setIsLoading(true);
            setlocation24hrSessionData([]);
            // const data = await BreathAPIs.get24hrSessionUtilizationMetric(location?._id, fromDate,new Date().getTimezoneOffset());
            const data = await BreathAPIs.getDashboardDayUtilizationData(fromDate,toDate,location?._id, true)
            setlocation24hrSessionData(data.data.data);
            // setChargersData(data.data.energyDetails.chargerDetails);
            
        } catch (error) {
            console.error('Error Fetching Location 24hr Session Utilisation data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchLocationFinancialData = async () => {
        try {
            setIsLocationLoading(true);
            setLocationFinancialData([]);
            const data = await BreathAPIs.getLocationFinancialData(location?._id, fromDate, toDate);
            setLocationFinancialData(data.data.data);
        } catch (error) {
            console.error('Error fetching location data:', error);
        } finally {
            setIsLocationLoading(false);
        }
    };

    const fetchLocationUtilizationData = async () => {
        try {
            setIsLocationLoading(true);
            setLocationUtilizationData([]);
            const data = await BreathAPIs.getLocationUtilizationData(location?._id, fromDate, toDate, true);
            setLocationUtilizationData(data.data.data);
        } catch (error) {
            console.error('Error fetching location data:', error);
        } finally {
            setIsLocationLoading(false);
        }
    };

    useEffect(() => {
        if (isVisible) {
            setSelectedTopTab(0);
            fetchLocationData();
            setSelectedCharger(null);
        }
    }, [location, isVisible, fromDate, toDate]);

    useEffect(() => {
        if (isVisible) {
            if (selectedTopTab === 1) {
                fetchLocationFinancialData();
            }
            if (selectedTopTab === 2) {
                fetchLocationUtilizationData();
            }
            if(selectedTopTab === 3){
                fetchLocation24hrSessionUtilisationData();
            }
        }
    }, [selectedTopTab]);

    useEffect(() => {
        if (!isVisible) {
            setIsLoading(true);
        }
    }, [isVisible]);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          return (
            <div className={styles.customTooltip}>
              <p className="label">{`${payload[0].name}: $${(payload[0].value).toFixed(2)}`}</p>
            </div>
          );
        }
        return null;
      };

    return (
        <div className={styles.LocationMetric}>
            <div className={styles.switch} onClick={() => setIsVisible(isVisible ? false : true)}>{isVisible ? 'Hide' : 'Show'}</div>
            <div className='clearfix' />


            {isVisible ? <div className={styles.content}>
                {isLoading && <div className={`${styles.locationBlocks} ${styles.loading}`}>
                    <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                    <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                </div>}

                {!isLoading && <div className={styles.locationBlocks}>
                    <div>
                        <b>Location</b>

                        <div className={styles.topBlockContainer}>
                            <div className={styles.topBlock}>
                                <span>Location Name</span>
                                <span>{location?.locationName}</span>

                            </div>
                        </div>

                        <div className={styles.topTabs}>
                            <div className={selectedTopTab === 0 ? styles.active : undefined} onClick={() => setSelectedTopTab(0)}>Utilized Energy</div>
                            <div className={selectedTopTab === 1 ? styles.active : undefined} onClick={() => setSelectedTopTab(1)}>Financial Data</div>
                            <div className={selectedTopTab === 2 ? styles.active : undefined} onClick={() => setSelectedTopTab(2)}>Booking Utilization</div>
                            <div className={selectedTopTab === 3 ? styles.active : undefined} onClick={() => setSelectedTopTab(3)}>Utilization</div>

                        </div>

                        {isLocationLoading &&
                            <div className={`${styles.locationBlocks} ${styles.loading} mt-4`}>
                                <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                                <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                            </div>
                        }



                        {selectedTopTab === 0 && <>

                            <div className={styles.topBlockContainer}>
                                <div className={styles.topBlock}>
                                    <span>Total Sessions</span>
                                    <span>{locationMetricData.sessionCount}</span>
                                </div>
                                <div className={styles.topBlock}>
                                    <span>Total Utilized Energy</span>
                                    <span>{locationMetricData.totalUtilizedEnergy?.toFixed(4)} kWh</span>
                                </div>
                            </div>


                            {!(chargersData == null || chargersData?.length == 0) ?
                                <div className={styles.bottomBlockContainer}>
                                    <div className={styles.bottomBlock}>
                                        <span>{formatDate(locationMetricData?.filterByDate?.from)} - {formatDate(locationMetricData?.filterByDate?.to)}</span>


                                        <ResponsiveContainer width="100%" height={300} >
                                            <LineChart data={locationMetricData?.graphResult} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="_id" />
                                                <YAxis yAxisId="left" stroke="#ff7300" />
                                                <YAxis yAxisId="right" orientation="right" stroke="#387908" />
                                                <Tooltip />
                                                <Legend />
                                                <Line yAxisId="left" name={'Total Utilized Energy'} type="monotone" dataKey="totalUtilizedEnergy" stroke="#ff7300" activeDot={{ r: 8 }} />
                                                <Line yAxisId="right" type="monotone" name={'Session Count'} dataKey="sessionCount" stroke="#387908" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                :
                                <div className={styles.noChargers}>No Data Available</div>
                            }
                        </>}

                        {!isLocationLoading && selectedTopTab === 1 && <>
                            <div className={styles.topBlockContainer}>
                                <div className={styles.topBlock}>
                                    <span>Revenue</span>
                                    <span>${locationFinancialData.Debit?.toFixed(2)}</span>
                                </div>
                                {/* <div className={styles.topBlock}>
                                    <span>Total Credit</span>
                                    <span>{locationFinancialData.Credit?.toFixed(2)}</span>
                                </div>
                                <div className={styles.topBlock}>
                                    <span>Booking Cancellation Amount</span>
                                    <span>{locationFinancialData.BookingCancellationAmount?.toFixed(2)}</span>
                                </div> */}
                            </div>

                            {!(locationFinancialData == null || locationFinancialData?.length == 0) ?
                                <div className={styles.bottomBlockContainer}>
                                    <div className={styles.bottomBlock}>
                                                                     
                                        <ResponsiveContainer width="100%" height={300} >
                                            <PieChart width={730} height={250}>
                                                <Pie data={locationFinancialData?.graphResult}
                                                    dataKey="value"
                                                    nameKey="name"
                                                    cx="50%"
                                                    cy="50%"
                                                    outerRadius={100}
                                                    fill="#40546e"
                                                    // label={({ name, percent }) => `${(percent * 100).toFixed(2)}%`}
                                                    >

                                                    {locationFinancialData?.graphResult.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                                <Tooltip content={<CustomTooltip/>}/>
                                                <Legend />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                :
                                <div className={styles.noChargers}>No Data Available</div>
                            }
                        </>}

                        {!isLocationLoading && selectedTopTab === 2 && <>
                            {/* <div className={styles.topHead}>
                                Today's
                                <div className={styles.topBlockContainer}>
                                    <div className={styles.topBlock}>
                                        <span>Utilization</span>
                                        <span>{(locationUtilizationData?.utilizationPercentageCurrentDay ?? 0).toFixed(2)}%</span>
                                    </div>
                                    <div className={styles.topBlock}>
                                        <span>Day Utilization</span>
                                        <span>{(locationUtilizationData?.dayUtilizationPercentageCurrentDay ?? 0).toFixed(2)}%</span>
                                    </div>
                                </div>
                                <div className={styles.topBlockContainer}>
                                    <div className={styles.topBlock}>
                                        <span>Utilized Time</span>
                                        <span>{isNaN(locationUtilizationData?.totalUtilizedTimeCurrentDay) ? '0m' : formatDuration(locationUtilizationData?.totalUtilizedTimeCurrentDay)}</span>
                                    </div>
                                    <div className={styles.topBlock}>
                                        <span>Booking Duration</span>
                                        <span>{isNaN(locationUtilizationData?.totalBookingDurationInSecondsCurrentDay) ? '0m' : formatDuration(locationUtilizationData?.totalBookingDurationInSecondsCurrentDay)}</span>
                                    </div>
                                    <div className={styles.topBlock}>
                                        <span>Bookings</span>
                                        <span>{(locationUtilizationData?.numberOfBookingsCurrentDay ?? 0).toFixed(0)} Nos</span>
                                    </div>
                                </div>  
                            </div> */}
                            <div className={`${styles['topHead']} ${styles['bottomRound']}`}>
                                {/* Whole Time */}
                                <span>{formatDate(locationUtilizationData?.dateRange?.fromDate )} - {formatDate(locationUtilizationData?.dateRange?.toDate )}</span>
                                <div className={styles.topBlockContainer}>
                                    <div className={styles.topBlock}>
                                        <span>Utilization</span>
                                        <span>{(locationUtilizationData?.utilizationPercentage ?? 0).toFixed(2)}%</span>
                                    </div>
                                    <div className={styles.topBlock}>
                                        <span>Day Utilization</span>
                                        <span>{(locationUtilizationData?.dayUtilizationPercentage ?? 0).toFixed(2)}%</span>
                                    </div>
                                </div>  
                                <div className={styles.topBlockContainer}>
                                    <div className={styles.topBlock}>
                                        <span>Utilized Time</span>
                                        <span>{isNaN(locationUtilizationData?.totalUtilizedTime) ? '0m' : formatDuration(locationUtilizationData?.totalUtilizedTime)}</span>
                                    </div>
                                    <div className={styles.topBlock}>
                                        <span>Booking Duration</span>
                                        <span>{isNaN(locationUtilizationData?.totalBookingDurationInSeconds) ? '0m' : formatDuration(locationUtilizationData?.totalBookingDurationInSeconds)}</span>
                                    </div>
                                    <div className={styles.topBlock}>
                                        <span>Bookings</span>
                                        <span>{(locationUtilizationData?.numberOfBookings ?? 0).toFixed(0)} Nos</span>
                                    </div>
                                </div>
                            </div>

                            {!(chargersData == null || chargersData?.length == 0) ?
                                <div className={styles.bottomBlockContainer}>
                                    <div className={styles.bottomBlock}>
                                        <span>{formatDate(locationUtilizationData?.filterResult?.filterRange?.fromDate)} - {formatDate(locationUtilizationData?.filterResult?.filterRange?.toDate)}</span>

                                        <ResponsiveContainer width="100%" height={300} >
                                            <LineChart data={locationUtilizationData?.filterResult?.result} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="_id" />
                                                <YAxis yAxisId="three" orientation="left" stroke="#ff7300" />
                                                <YAxis yAxisId="four" orientation="right" stroke="#387908" />
                                                <Tooltip />
                                                <Legend />
                                                <Line yAxisId="three" type="monotone" name={'Number Of Bookings'} dataKey="numberOfBookingsFiltered" stroke="#ff7300" />
                                                <Line yAxisId="four" type="monotone" name={'Utilization Percentage'} dataKey="percentageUtilization" stroke="#387908" />
                                                <Line yAxisId="four" type="monotone" name={'Day Utilization Percentage'} dataKey="singleDayUtilizationPercentage" stroke="#4ae94a" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                :
                                <div className={styles.noChargers}>No Data Available</div>
                            }

                        </>}

                        {selectedTopTab === 3 && <>

                                        <div className={styles.topBlockContainer}>
                                            <div className={styles.topBlock}>
                                                <span>Total Sessions</span>
                                                <span>{location24hrSessionData.sessionCount24hrs}</span>
                                            </div>
                                            <div className={styles.topBlock}>
                                                <span>Total Utilized Energy</span>
                                                <span>{location24hrSessionData.totalUtilizedEnergy24hrs?.toFixed(4)} kWh</span>
                                            </div>
                                        </div>


                                        {!(location24hrSessionData == null || location24hrSessionData?.length == 0) ?
                                           
                                            <div className={styles.bottomBlockContainer}>
                                                <div className={styles.bottomBlock}>
                                                    {console.log(formatDate(fromDate)===formatDate(toDate),  formatDate(fromDate)===formatDate(new Date()))}
                                                    {console.log("to date: ", toDate, formatDate(toDate))}
                                                    <span>{formatDate(fromDate)}   {(formatDate(fromDate)===formatDate(toDate)) ? "" : " - "+(formatDate(toDate))}</span>
                                                  
                                                      
                                                    <ResponsiveContainer width="100%" height={300} >
                                                        <BarChart data={location24hrSessionData.viewDayUtilisation} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="startTime" />
                                                            <YAxis  stroke="#ff7300" domain={[0, 100]} />
                                                            {/* <Tooltip  /> */}
                                                            <Tooltip content={<CustomTooltip2 />} />
                                                            <Legend />
                                                            <Bar name={'Normalised Session Utilisation Percentage'} dataKey="timeUtilisation"  fill="#82ca9d" />
                                                            
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                   
                                                </div>
                                            </div>
                                            :
                                            <div className={styles.noChargers}>No Data Available</div>
                                        }
                         </>}

                    </div>

                    <div>
                        <div className={styles.chargerHead}>
                            <span className={selectedCharger ? styles.withCharger : undefined} onClick={() => { setSelectedCharger(null) }}>Chargers</span> {selectedCharger ? '>' : ''}  {selectedCharger ? <span>{selectedCharger.chargerName}</span> : undefined}
                        </div>
                        {!selectedCharger && chargersData?.map((charger) => (
                            <div onClick={() => { setSelectedCharger(charger) }} className={styles.charger} key={charger?.chargerName}>{charger?.chargerName}<span>{charger?.chargerStatus}</span></div>
                        ))}

                        {chargersData == null || chargersData?.length == 0 && <div className={styles.noChargers}>No chargers Available</div>}

                        {selectedCharger ? <ChargerMetric charger={selectedCharger} fromDate={fromDate} toDate={toDate} /> : undefined}
                    </div>
                </div>}
            </div> : undefined}

        </div>
    );
};

export default LocationMetric;
